import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/auth.service';

/**
 * Protect admin routes — if user is not admin, redirect to home
 */
export default function AdminRoute({ children }) {
  try {
    if (authService.isAdmin()) return children;
  } catch (e) {
    console.warn('AdminRoute check failed', e);
  }
  return <Navigate to="/" replace />;
}
